import { Resizable } from "@/common/Resizable";
import { useFullRelease } from "@/common/hooks_useFullRelease";
import AttributeInfo from "@/components/GraphVisualisation/components/AttributeInfo/AttributeInfo";
import AttributeValues from "@/components/GraphVisualisation/components/AttributeInfo/AttributeValues";
import RuleGraphProvider from "@/components/GraphVisualisation/providers/RuleGraphProvider";
import styled from "@emotion/styled";
import AttributeSelectedProvider from "@imminently/decisively-ui/AttributeSelectedProvider";
import GraphProvider from "@imminently/decisively-ui/GraphProvider";
import ReleaseProvider from "@imminently/decisively-ui/ReleaseProvider";
import React from "react";
import { useDecisionGraphOf } from "@/common/hooks_useResultDecisionGraph";
import type { VisibleMask } from "@/components/GraphVisualisation/decisionGraphView";
import { isDecisionGraph } from "@imminently/decisively-core";

const StyledResizable = styled(Resizable)`
  .Pane2 {
    margin: 0;
  }
`;

export interface FocusNodeProps {
  node: any;
  /** A DecisionGraph, or a saved result's legacy JSON graph (converted to one). */
  graph: any;
  /** With a DecisionGraph: the ids in the view. */
  visible?: VisibleMask;
  onNodeChange: (node: any) => void;
}

const FocusNode = (props: FocusNodeProps) => {
  const { node, onNodeChange, visible = null } = props;
  const release = useFullRelease();
  const graph = useDecisionGraphOf(props.graph) ?? null;

  return (
    <div className="relative h-full">
      <ReleaseProvider release={release}>
        <GraphProvider graph={graph as any}>
          <RuleGraphProvider
            onSelectedNodeChange={onNodeChange}
            startNode={node}
            debug={true}
            graph={graph}
            visible={isDecisionGraph(props.graph) ? visible : null}
          >
            <AttributeSelectedProvider
              onSelectAttribute={(node) => {
                if (node.hidden) {
                  return;
                }
                onNodeChange(node);
              }}
            >
              <StyledResizable
                split="vertical"
                defaultSize="50%"
                pane1Style={{
                  minWidth: "max(30%, 400px)",
                  overflow: "hidden",
                }}
                pane2Style={{ overflow: "hidden" }}
                allowResize
              >
                <AttributeInfo
                  showTitle={false}
                  showInputValues={false}
                />
                <AttributeValues />
              </StyledResizable>
            </AttributeSelectedProvider>
          </RuleGraphProvider>
        </GraphProvider>
      </ReleaseProvider>
    </div>
  );
};
export default FocusNode;
